import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { isMobile } from 'react-device-detect';

const Core = () => {
  return (
    <div>
        <section className='bg-white py-lg-10 py-8'>
            <div className='container-fluid px-lg-3 px-3'>
                <div className='row justify-content-center'>
                    <div className='col-lg-12'>
                        <div className='px-lg-6 mb-2 mb-lg-0'>
                        <div className='display-2 fw-semibold text-dark'>
                             Core Values. <span className='fs-4 text-primary'>What makes us Excellent!</span>
                        </div>
                        </div>

                        <div className='pt-lg-6 pt-6 pb-lg-6 pb-6'>

                        <Swiper
                        modules={[Autoplay]}
                        spaceBetween={isMobile ? 0 : 0}
                        slidesPerView={1} // default (mobile)
                        loop={true}
                        autoplay={{
                            delay: 0, // no delay between slides
                            disableOnInteraction: false,
                            waitForTransition: false, // keeps moving
                        }}
                        speed={8000} // continuous smooth speed
                        breakpoints={{
                            768: {
                            slidesPerView: 3, // tablet
                            },
                            1024: {
                            slidesPerView: 4, // desktop
                            },
                        }}
                        >
                        {[1, 2, 3, 4, 5, 6, 7].map((num) => (
                            <SwiperSlide key={num}>
                            <div className="text-center">
                                <img
                                src={`../../assets/images/background/core/${num}.svg`}
                                alt={`Core ${num}`}
                                className="img-fluid"
                                width={isMobile ? "90%" : "80%"}
                                style={{
                                    borderRadius: "30px",
                                }}
                                />
                            </div>
                            </SwiperSlide>
                        ))}
                        </Swiper>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
  )
}

export default Core